import { Dimensions } from 'react-native';
import { faBell } from '@fortawesome/pro-solid-svg-icons/faBell';
import { faBellOn } from '@fortawesome/pro-solid-svg-icons/faBellOn';
import { faBellSlash } from '@fortawesome/pro-solid-svg-icons/faBellSlash';
import { faBell as faBellOutline } from '@fortawesome/pro-regular-svg-icons/faBell';
import { faAt } from '@fortawesome/pro-solid-svg-icons/faAt';
import { faPencil } from '@fortawesome/pro-solid-svg-icons/faPencil';
import { faHeart } from '@fortawesome/pro-solid-svg-icons/faHeart';
import { faReply } from '@fortawesome/pro-solid-svg-icons/faReply';
export const CHANNEL_PHOTO_INDEX = 236; // https://picsum.photos id used as temporary placeholder
export const CHANNEL_PHOTO_SIZE = 'sm';

// avatar size
export const AVATAR_SIZE = 240;

// debounce delay
export const DEBOUNCE_DELAY = 1300;

// device width and height
export const {
  width: DEVICE_WIDTH,
  height: DEVICE_HEIGHT
} = Dimensions.get('window');

// editor size
export const EDITOR_HEIGHT = '150px';
export const EDITOR_MAX_HEIGHT = '200px';

// languages
export const LANGUAGES = {
  PLACEHOLDERS: {
    NEW_TOPIC: 'Start a new conversation...',
    EDITOR: "What's on your mind?",
    FLAG_POST: 'Why do you want to flag this post?',
    CHOOSE_CATEGORY: 'Choose category...',
    MOVE_POST: 'Enter topic title...',
    SEND_PM: 'Say something to',
    SEARCH_USERS: "Enter user's name...",
    SEARCH_FORUM: 'Search forum...',
    SEARCH_FORUM_CATEGORY: 'Select category...'
  },
  // posts
  HANDLE_DELETE_POST_MESSAGE: 'You can only delete posts you own.',
  UNLIKE_TIME_LIMIT_EXCEEDED: 'You cannot unlike this post any longer.',
  // popups
  CONFIRM_DECISION: 'Are you sure? This cannot be undone.',
  // private messages
  USER_HAS_OPTED_OUT: 'Currently this user does not want to receive any direct messages.',
  // tooltips
  TOOLTIP: {
    mention: 'Mention anyone in the community so they can join the conversation!'
  }
};

// max replies per batch - match batch in discourse
export const MAX_REPLIES_PER_BATCH = 20;
export const MIN_REPLIES_TO_SHOW = 5;

// post modal
export const MODAL_WIDTH = 'xl';
export const IS_SMALLER_DEVICE = DEVICE_WIDTH < 400;
export const NEW_TOPIC_MODAL_MIN_HEIGHT = '500px';
export const NEW_REPLY_MODAL_MIN_HEIGHT = '400px';
export const EDIT_MODAL_MIN_HEIGHT = '400px';

// notification data
export const FILTERS_LIST = ['all', 'read', 'unread'];
export const TYPE_MENTION = 1;
export const TYPE_REPLY = 2;
export const TYPE_EDITED = 4;
export const TYPE_LIKE = 5;
export const TYPE_POST = 9;
export const TYPE_IDS_TO_EXCLUDE = [6, 12, 16]; // private messages, badge, admin inbox in order
export const SYSTEM_USER_NAMES = ['system', 'discobot'];
export const IGNORABLE_PM_SLUGS = ['greetings', 'congratulations-you-ve-been-granted-moderator-status', 'congratulations-you-ve-been-granted-admin-status'];
export const NOTIFICATIONS_TABS = [{
  name: 'Activity',
  value: 0,
  isInUse: true
}, {
  name: 'Messages',
  value: 1
},
// to be added
{
  name: 'Sent',
  value: 2
} // to be added
];

export const NOTIFICATION_PREVIEW_LENGTH = 3;
export const NOTIFICATION_TYPE_ICONS = [{
  name: 'mention',
  type: TYPE_MENTION,
  icon: faAt
}, {
  name: 'edit',
  type: TYPE_EDITED,
  icon: faPencil
}, {
  name: 'like',
  type: TYPE_LIKE,
  icon: faHeart
}, {
  name: 'post',
  type: TYPE_POST,
  icon: faReply
}, {
  name: 'reply',
  type: TYPE_REPLY,
  icon: faReply
}];

// messagebus
export const MESSAGE_BUS_CALLBACK_INTERVAL = 500;
export const MESSAGE_BUS_LAST_ID = {
  get_all_new_messages: -1,
  get_entire_backlog: 0
};
export const MESSAGE_BUS_REPLY_MSG_MAX_CHARS = 20;
export const MESSAGE_BUS_REPLY_MSG_SPACE_INDEX = 15;
export const MESSAGE_BUS_SCRIPT_EXISTS_POLL_COUNT = 50;

// logging
export const LOG = {
  bullet: '  \u2022',
  check: '\u2713',
  crossMark: '\u274C',
  whiteBullet: '    \u25E6'
};

// image resizer
const space = {
  contentMarginLeft: 8,
  contentBorderLeft: 1,
  contentBorderRight: 2,
  contentPaddingRight: 4,
  iconColumn: 32,
  containerPaddingLeft: 16,
  containerPaddingRight: 16
};
export const RESIZER_REPLY_EXTRA_SPACE = Object.values(space).reduce((a, b) => a + b, 0);
export const BASE_MULTIPLE = 0.92;

// post action types
export const POST_ACTION_TYPES = [{
  name: 'Off-topic',
  description: 'Post is irrelevant',
  value: 3
}, {
  name: 'Inappropriate',
  description: 'Post might be offensive or abusive',
  value: 4
}, {
  name: 'Spam',
  description: 'Post might be an advertisement',
  value: 8
}, {
  name: 'Something else',
  description: 'Post requires moderator attention',
  value: 7
}];
export const POST_ACTION_TYPE_IDS = {
  like: {
    value: 2
  }
};

// post length
export const TITLE_MIN_LENGTH = 10;
export const RAW_MIN_LENGTH = 20;

// flag post
export const FLAG_POST_REASON_MIN_LENGTH = 10;

// reply action codes
export const REPLY_ACTION_CODES = [{
  code: 'pinned.enabled',
  message: 'Topic pinned'
}, {
  code: 'pinned.disabled',
  message: 'Topic unpinned'
}, {
  code: 'pinned_globally.enabled',
  message: 'Topic pinned globally'
}, {
  code: 'pinned_globally.disabled',
  message: 'Topic unpinned globally'
}];

// search constants
export const SEARCH_RESULTS_MAX = 50; // this is hard coded value by Discourse
export const SEARCH_TERM_MIN = 3;
export const PREVIEW_LENGTH = 3;

// watching status list
export const WATCHING_STATUS_LIST = [{
  text: 'Muted',
  value: 0,
  icon: faBellSlash
}, {
  text: 'Normal',
  value: 1,
  icon: faBellOutline
}, {
  text: 'Tracking',
  value: 2,
  icon: faBell
}, {
  text: 'Watching',
  value: 3,
  icon: faBellOn
}];

// z-index
export const Z_INDEX = {
  top: 100
};

// tag length
export const TAG_LENGTH_LIMIT = 256;

// search users limit
export const SEARCH_USERS_LIMIT = 10;

// base font size
export const BASE_FONT_SIZE = 16;

// line height
export const LINE_HEIGHT = '24px';

// inline style for mention blot
export const MENTION = {
  BORDER_RADIUS: '6px',
  TEXT_DECORATION: 'none',
  TEXT_ALIGN: 'center',
  WIDTH_MULTIPLIER: 10,
  MAX_WIDTH_MULTIPLIER: 11
};

// svg for mention icon
// html doesn't seem happy to be working with <FontAwesomeIcon />
// hence using svg
export const MENTION_ICON = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M256 64C150 64 64 150 64 256s86 192 192 192c17.7 0 32 14.3 32 32s-14.3 32-32 32C114.6 512 0 397.4 0 256S114.6 0 256 0S512 114.6 512 256v32c0 53-43 96-96 96c-29.3 0-55.6-13.2-73.2-33.9C320 371.1 289.5 384 256 384c-70.7 0-128-57.3-128-128s57.3-128 128-128c27.9 0 53.7 8.9 74.7 24.1c5.7-5 13.1-8.1 21.3-8.1c17.7 0 32 14.3 32 32v80 32c0 17.7 14.3 32 32 32s32-14.3 32-32V256c0-106-86-192-192-192zm64 192c0-35.3-28.7-64-64-64s-64 28.7-64 64s28.7 64 64 64s64-28.7 64-64z" /></svg>';

// menu placement
export const MENU_POSITION = 'bottom right';
//# sourceMappingURL=index.js.map